import axios from "axios";
import { $urlImage } from "./url";
import saveAs from "file-saver";
interface File {
  name: string;
  path: string;
}

export const downloadWithOriginalName = async (item: File) => {
  const url = $urlImage(item.path);

  if (!url) {
    throw new Error("Không có URL tài liệu");
  }

  const response = await axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });

  const blob = response.data as Blob;

  if (blob.type === "application/json") {
    const text = await blob.text();
    const error = JSON.parse(text);
    throw new Error(error?.message || "Tải tài liệu thất bại");
  }

  saveAs(blob, item.name || url.split("/").pop() || "download");
};
